import { render, staticRenderFns } from "./AsignaCondecoracionPersonalDialogComponent.vue?vue&type=template&id=665bae4e"
import script from "./AsignaCondecoracionPersonalDialogComponent.vue?vue&type=script&lang=js"
export * from "./AsignaCondecoracionPersonalDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports